<template>
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item v-for="(bc, index) in bcs" :key="'bc' + index"
                        :to="{ path: bc.path }"
      >{{bc.name}}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
	export default {
		props: {
			bcs: Array
    }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/widgets/Breadcrumb.vue